module.exports = __webpack_public_path__ + "static/live365-logo-gray-36920c69b978aa26258eaad9a9b1b13a.svg";